import { action, observable } from 'mobx'
import { observer } from 'mobx-react'
import React, { Component, Fragment } from 'react'
import styled from 'styled-components'
import Text from '../../components/Text'
import patient from '../../stores/patient'
import request from '../../utils/request'
import Header from './Header'
import NameDate from './NameDate'
import Notes from './Notes'

const LoadingIcon = styled.i`
  position: absolute;
  width: 100vw;
  height: 100vh;
  color: var(--gray);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 3rem;
`

const LogoWrap = styled.div`
  text-align: center;
  padding: 2rem 0;
`

const Logo = styled.img`
  width: 25%;

`

@observer
export default class PrintLogin extends Component {
  @observable loginID = ''
  @observable loginPassphrase = ''
  @observable loaded = false

  @action
  setLoginInfo = (id, passphrase) => {
    this.loginID = id
    this.loginPassphrase = passphrase
    this.loaded = true
  }

  getLoginInfo = async () => {
    if (patient.fields._id === 'demo') {
      this.setLoginInfor('demo patient ID', 'demo patient passphrase')
      return
    }
    
    const req = await request('/api/patientAuth/generateLogin', { patientID: patient.fields._id })

    if (req.success) {
      this.setLoginInfo(req.data.loginID, req.data.loginPassphrase)
    }
  }

  componentDidMount() {
    this.getLoginInfo()
  }

  render() {
    if (!this.loaded) {
      return <LoadingIcon><i className="fas fa-sync fa-spin" /></LoadingIcon>
    }

    return (
      <Fragment>
        <LogoWrap><Logo src="/images/logo-long.png" alt="" /></LogoWrap>
        <NameDate />
        <Header str="titles.loginInformation" />
        <Notes>
          <Text str="prose.hereIsYourLoginInformation" /><br /><br />
          <Text str="prose.loginURL" />{' '}<b>https://seeglaucoma.org/patient-login</b><br />
          <Text str="prose.loginID" />{' '}<b>{this.loginID}</b><br />
          <Text str="prose.passphrase" />{' '}<b>{this.loginPassphrase}</b><br />
        </Notes>
      </Fragment>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/Print/PrintLogin.js